module.exports = __webpack_public_path__ + "img/gy_img10.ddecd997.png";